<template>
    <div id="widget-modal" class="modal fade" role="dialog">
        <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <div id="destinidiv" src></div>
        </div>
        <button type="button" class="close close--mobile" data-dismiss="modal">&times;</button>
    </div>
</template>

<script>
export default {
    name: "destini-modal"
};
</script>

<style lang="scss" scoped>
    @import "./../variables";
    @import "./static/libs/bootstrap-modified";

    .modal {
        padding-top: 50px;
    }
    #widget-modal .modal-body {
        text-align: center;
        width: 100%;
        max-width: 840px;
        min-width: 300px;
        height: auto;
        margin-left: auto;
        margin-right: auto;
        max-height: 750px !important;
        padding: 0px;
    }
    .modal-open .modal {
        background-color: rgba($color: #000000, $alpha: 0.6);
    }
    #widget-modal .close {
        position: relative;
        margin-right: -30px;
        color: #fff;
        margin-top: -30px;
        font-size: 40px;
        outline: 0;

        &--mobile {
            position: absolute;
            margin: 0 auto;
            top: 3px;

            @media (min-width: 768px) {
                display: none;
            }
        }
    }

    #destinidiv {
        background: #fff;
        width: 100%;
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/DestiniModal.vue